import React from 'react';
import './styles.scoped.scss';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../../assets/constants/strings';

// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import { dummyData, CATEGORY_ORDER } from '../../../../../services/dummy';

const RequestItem = ({
  title,
  request = 'GET',
  url,
  handleApiRequest,
  type = '',
  body = '',
  active = false,
}) => {
  let color = 'primary';
  switch (request) {
    case 'POST':
      color = 'success';
      break;
    case 'PUT':
      color = 'warning';
      break;
    case 'DELETE':
      color = 'danger';
      break;
    default:
      color = 'primary';
      break;
  }

  return (
    <div
      className={`request-item d-flex align-items-center my-1 ${
        active ? 'request-item--active' : ''
      }`}
      role='button'
      title={url}
      onClick={() =>
        handleApiRequest({
          url,
          headers: [],
          // Seed the body with the endpoint's default (POST endpoints) so the
          // request is ready to send; GET endpoints get an empty body.
          jsonInput: body,
          apiKey: '',
          data: [],
          type,
        })
      }
    >
      <span className={`badge badge-${color} request-item__method`}>
        {request}
      </span>
      <span className='request-item__title'>{title}</span>
    </div>
  );
};

export default function RequestMenu({ setRequest, selectedUrl }) {
  // Group endpoints by category for the menu, in the defined display order.
  // The accordion uuid must be a valid HTML5 id (no spaces), so slugify the
  // category for the uuid while keeping the original text as the heading.
  const catUuid = (category) => `cat-${category.replace(/\s+/g, '-')}`;
  const categories = CATEGORY_ORDER.map((category) => ({
    category,
    items: dummyData.filter((item) => item.category === category),
  })).filter((group) => group.items.length > 0);

  return (
    <Accordion
      allowMultipleExpanded={true}
      allowZeroExpanded={true}
      preExpanded={['getting-started', ...categories.map((g) => catUuid(g.category))]}
    >
      <AccordionItem uuid='getting-started'>
        <AccordionItemHeading>
          <AccordionItemButton>Getting Started</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className='getting-started'>
            <p className='mb-2'>
              Try the RegulationCity API without writing any code:
            </p>
            <ol className='pl-3 mb-2'>
              <li>Pick an endpoint from the list below.</li>
              <li>
                Adjust the document or section id in the URL if you want.
              </li>
              <li>
                Hit <b>Send</b> and inspect the JSON response.
              </li>
            </ol>
            <p className='mb-0'>
              Requests run against your account. See the{' '}
              <Link to={ROUTES.APIDocs}>documentation</Link> for parameters and
              response shapes.
            </p>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
      {categories.map((group) => (
        <AccordionItem key={group.category} uuid={catUuid(group.category)}>
          <AccordionItemHeading>
            <AccordionItemButton>{group.category}</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            {group.items.map((item, i) => (
              <RequestItem
                key={i}
                title={item.title}
                url={item.endpoint}
                request={item.request}
                handleApiRequest={setRequest}
                type={item.type}
                body={item.body ? JSON.stringify(item.body, null, 2) : ''}
                active={selectedUrl === item.endpoint}
              />
            ))}
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
